import axios from 'axios'
import router from '../router'
import { store } from '../store/index'
import Vapi from 'vuex-rest-api'
import Csrf from './csrf'
const DynamicRestApi = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT,
	withCredentials: true
})

DynamicRestApi.interceptors.response.use((response) => {
	return response
}, (error) => {
	if (error.response.status === 401) {
		router.push('/login')
		store.commit('auth/clearUserData')
	}
	return Promise.reject(error)
})

const API_URL = '/api/'
export function buildModule (models) {
	let multiProperty, singleProperty, postPath, putPath, getPath, listPath, deletePath
	if (models.length === 1) {
		const singleModel = models[0]
		const multiModel = singleModel + 's'
		multiProperty = multiModel
		singleProperty = singleModel

		const pathPrefix = API_URL + multiModel
		postPath = (args) => `${pathPrefix}`
		putPath = (args) => `${pathPrefix}/${args[0]}`
		getPath = (args) => `${pathPrefix}/${args[0]}`
		listPath = (args) => `${pathPrefix}`
		deletePath = (args) => `${pathPrefix}/${args[0]}`
	} else {
		multiProperty = models[0] + models[1] + 's'
		singleProperty = models[0] + models[1]
		postPath = (args) => `${API_URL}${models[0]}s/${args[0]}/${models[1]}s`
		putPath = (args) => `${API_URL}${models[0]}s/${args[0]}/${models[1]}s/${args[1]}`
		getPath = (args) => `${API_URL}${models[0]}s/${args[0]}/${models[1]}s/${args[1]}`
		listPath = (args) => `${API_URL}${models[0]}s/${args[0]}/${models[1]}s`
		deletePath = (args) => `${API_URL}${models[0]}s/${args[0]}/${models[1]}s/${args[1]}`
	}

	const state = {
		newItem: null,
		singleItem: null,
		items: []
	}

	return new Vapi({
		axios: DynamicRestApi,
		state: state
	})
		.post({
			action: 'post',
			property: 'newItem',
			path: postPath,
			beforeRequest: async (state, { params, data }) => {
				await Csrf.getCookie()
			}
		})
		.put({
			action: 'put',
			path: putPath,
			beforeRequest: async (state, { params, data }) => {
				await Csrf.getCookie()
			}
		})
		.get({
			action: 'get',
			property: 'singleItem',
			path: getPath,
			beforeRequest: async (state, { params, data }) => {
				await Csrf.getCookie()
			}
		})
		.get({
			action: 'list',
			property: 'items',
			path: listPath,
			beforeRequest: async (state, { params, data }) => {
				await Csrf.getCookie()
			}
		}).delete({
			action: 'delete',
			path: deletePath,
			beforeRequest: async (state, { params, data }) => {
				await Csrf.getCookie()
			}
		})
		.getStore({
			namespaced: true
		})
}

export default DynamicRestApi
